import { Box, Image, Text } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL_MEDIA } from "../../../../Redux/App/action";

const AllCardData = () => {
  const [data, setData] = useState([]);

  const getAllCards = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/media/file/admin/get/bygroupandcategoryanddimension?imageGroup=CARDS&categoryId=1`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  useEffect(() => {
    getAllCards();
  }, []);
  return (
    <Box
      w="full"
      alignItems="center"
      p={{ md: 5, base: 1 }}
      gap={5}
      display={"grid"}
      gridTemplateColumns={{ md: "repeat(3,1fr)", base: "repeat(1,1fr)" }}
    >
      {data &&
        data.map((el, i) => (
          <Box
            key={i}
            w={{ md: "xs", base: "90%" }}
            bg="white"
            shadow="lg"
            rounded="lg"
            overflow="hidden"
            mx="auto"
          >
            <Image w={"full"} src={el.imageUrl} alt="avatar" />
            <Box py={5} textAlign="center">
              <Text
                fontWeight="semibold"
                as="h4"
                color={"black"}
                lineHeight="tight"
                noOfLines={1}
              >
                {el.mediaName}
              </Text>
              <Box>{el.comments}</Box>
            </Box>
          </Box>
        ))}
    </Box>
  );
};

export default AllCardData;
